import script from "./ImagePickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePickerModal.vue?vue&type=script&setup=true&lang=js"

import "./ImagePickerModal.vue?vue&type=style&index=0&id=198a10c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198a10c9"]])

export default __exports__